import { BrowserHistory, createBrowserHistory } from 'history';

let history: BrowserHistory;

/**
 * The router (react-router-dom) expects history and location objects as props,
 * so this exposes a singleton instance of the history object so that the App
 * component can initialize the router. This also makes sure the same history
 * instance can be accessed by any component (FC) if necessary
 *
 * @param globalHistory - optional history object to use instead of creating a new one.
 *        This argument comes exclusively from the DSRModule, as it extracts
 *        the history object from its consumer app when it's used as a federated module.
 */
const useHistory = (globalHistory?: BrowserHistory) => {
  if (!history) {
    history = globalHistory || createBrowserHistory();
  }
  return history;
};

export default useHistory;
